import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera, CheckCircle2, FileText, Loader2 } from "lucide-react";
import { errText, shrinkImage } from "@/lib/bf";

const TXT = {
  buletin: ["Fotografiază buletinul", "Buletin atașat · refă poza", "Citesc buletinul…"],
  foaie: ["Fotografiază foaia cu datele (buletin nou)", "Foaie atașată · refă poza", "Citesc foaia…"],
};

export default function BFCiPhoto({ reader, onRead, done, testid, part = "buletin" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = (file) => {
    if (!file) return;
    setBusy(true);
    shrinkImage(file, 2000).then((img) => reader(img, part)).then((r) => {
      const f = r.fields || {};
      const n = Object.values(f).filter(Boolean).length;
      onRead(f, r.doc.id);
      if (part === "buletin" && n && !f.domiciliu) toast.warning("Buletin nou, fără domiciliu: fotografiază și foaia cu datele.");
      else toast[n ? "success" : "warning"](n ? "Am citit poza. Verifică datele completate." : "Poza e salvată, dar nu am putut citi datele. Completează-le manual.");
    }).catch((e) => toast.error(errText(e, "Nu am putut încărca poza"))).finally(() => { setBusy(false); ref.current.value = ""; });
  };
  const [idle, ok, wait] = TXT[part];
  const Icon = part === "foaie" ? FileText : Camera;
  return (
    <>
      <input ref={ref} type="file" accept="image/*" capture="environment" hidden onChange={(e) => pick(e.target.files?.[0])} data-testid={`${testid}-input`} />
      <button type="button" className="st-btn st-btn--light" onClick={() => ref.current.click()} disabled={busy} data-testid={testid}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : done ? <CheckCircle2 size={14} /> : <Icon size={14} />} {busy ? wait : done ? ok : idle}
      </button>
    </>
  );
}
